import { Grid, GridProps } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import {
  AlertPosition,
  AlertSeverity,
  FormikSubmitButton,
  FormikSubmitButtonProps,
  SubmitAlert,
  SubmitAlertProps
} from '.'
import { useAlert } from '../contexts'

const useStyles = makeStyles(() => ({
  saveError: {
    color: 'red'
  }
}))

interface AlertProps extends Omit<SubmitAlertProps, 'alertType'> {
  alertPosition: AlertPosition
  gridProps?: GridProps
}

export interface SubmitButtonWithAlertProps extends FormikSubmitButtonProps {
  alertProps: AlertProps
  justifyContent?: GridProps['justifyContent']
}

export const SubmitButtonWithAlert = ({
  alertProps,
  buttonProps,
  justifyContent = 'flex-start'
}: SubmitButtonWithAlertProps) => {
  const classes = useStyles()

  const { alertPosition, ...submitAlertProps } = alertProps

  const { alertType } = useAlert()

  const alertSeverity = alertType?.severity

  const alertGrid = alertSeverity && (
    <Grid item md="auto" xs={12}>
      <SubmitAlert alertType={alertType} {...submitAlertProps} />
    </Grid>
  )

  const buttonGridProps =
    justifyContent === 'flex-end' ? {} : { md: true, xs: true }

  return (
    <Grid
      container
      alignItems="center"
      justifyContent={justifyContent}
      spacing={2}
    >
      {alertPosition === AlertPosition.LEFT && alertGrid}
      <Grid item {...buttonGridProps}>
        <FormikSubmitButton
          buttonProps={{
            ...buttonProps,
            className:
              alertSeverity === AlertSeverity.ERROR ? classes.saveError : ''
          }}
        />
      </Grid>
      {alertPosition === AlertPosition.RIGHT && alertGrid}
    </Grid>
  )
}
